import Image from "next/image";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

type WoodsThinkingIconProps = ComponentProps<"span"> & {
  animated?: boolean;
};

/** Decorative Woods mark used alongside a visible loading label. */
export function WoodsThinkingIcon({
  animated = true,
  className,
  ...props
}: WoodsThinkingIconProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex shrink-0 items-center justify-center", className)}
      {...props}
    >
      <Image
        alt=""
        className="size-full"
        height={37}
        loading="eager"
        src={animated ? "/woods_icon_animated.svg" : "/woods-icon.svg"}
        unoptimized
        width={37}
      />
    </span>
  );
}

/**
 * Inline loading indicator shown while the assistant is working but no
 * labelled reasoning row is available yet.
 */
export function ThinkingIndicator() {
  return (
    <span
      className="inline-flex items-center"
      role="status"
      aria-live="polite"
    >
      <WoodsThinkingIcon className="size-6" />
      <span className="sr-only">Thinking…</span>
    </span>
  );
}
